module.exports = __webpack_public_path__ + "img/powered_by_sipay3.92982a70.png";